import Image from '@/components/shared/Image';

type EmptyStateProps = {
  hasInitialParams: boolean;
};

export const EmptyState = ({ hasInitialParams }: EmptyStateProps) => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-[7.5rem] px-4 py-20 md:flex-row">
      <div className="mt-8 flex max-w-lg flex-col gap-2 md:mt-0">
        <h3 className="font-publico text-[32px] font-bold leading-[40px] text-grey-900">
          {!hasInitialParams ? (
            'Preencha os campos de busca'
          ) : (
            <>
              Desculpe, <br />
              não encontramos sua busca.
            </>
          )}
        </h3>
        <p className="text-xl">
          {!hasInitialParams
            ? 'Para começar sua busca, você deve inicialmente preencher os campos segmento, produto e estado.'
            : 'Por favor, faça uma nova pesquisa ou entre em contato conosco pelos nossos canais disponíveis.'}
        </p>
      </div>
      <div>
        <Image
          src="/assets/images/help-center/dog.png"
          width={323}
          height={243}
          alt="Sem resultados"
        />
      </div>
    </div>
  );
};
